import { z } from 'zod';
import { StrengthTraitSlugListSchema } from './strength-traits';

/** Личная заметка автора об участнике в разрезе конкретного события. */
export const ParticipantDossierDto = z.object({
  subjectUserId: z.uuid(),
  eventId: z.uuid(),
  note: z.string().max(2000),
  strengthSlugs: StrengthTraitSlugListSchema,
  updatedAt: z.iso.datetime(),
});

export type ParticipantDossierDto = z.infer<typeof ParticipantDossierDto>;

/** eventId и subjectUserId приходят путём — в теле только содержимое заметки. */
export const UpsertParticipantDossierInput = z.object({
  note: z.string().max(2000),
  strengthSlugs: StrengthTraitSlugListSchema,
});

export type UpsertParticipantDossierInput = z.infer<typeof UpsertParticipantDossierInput>;
